import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PageSEO from "../components/SEO_Component/PageSEO";
import Card2 from "../components/Card2";
import Navbar from "../components/NavBar";
import useAnalyticsEventTracker from "../hooks/useAnalyticsEventTracker";

function HomePage() {
  const [categoriesList, setCatList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [seo, setSEO] = useState({});
  const { lang } = useParams();

  const gaEventTracker = useAnalyticsEventTracker("Home");

  function extractLastSegment(url) {
    const urlObject = new URL(url);
    const pathnameParts = urlObject.pathname.split("/");
    const lastSegment = pathnameParts[pathnameParts.length - 1];
    return lastSegment;
  }
  window.scrollTo({
    top: 0,
    behavior: "instant",
  });
  console.log(process.env.REACT_APP_API);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}${lang ? lang : "english"}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setCatList(data["categories"]);
        setSEO(data.seo);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
      });
  }, [lang]);

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}
      {!isLoading && (
        <div className="h-full flex-col items-center place-items-center">
          <PageSEO seoData={seo} />
          <h1 className="mt-4 text-[#00C6CA] text-base flex justify-center text-center font-semibold md:text-[40px] md:leading-[60.52px]">
            {seo.h1}
          </h1>
          <div className="mt-4 text-[#00000094] text-xs flex justify-center text-center font-montserrat font-normal md:text-[25px] md:mt-4 leading-6">
            {seo.data}
          </div>
          {seo.subtitle && (
            <div className="mt-4 text-[#00000099] text-base flex justify-center text-center font-montserrat font-semibold md:text-[25px] md:leading-3 md:my-6">
              {seo.subtitle}
            </div>
          )}

          <div className="md:flex md:mx-28 lg:mx-32 md:my-16 md:px-3">
            <div className="md:grid md:grid-cols-3 md:gap-4">
              {categoriesList.map((category) => (
                <Link to={`${extractLastSegment(category.url)}`}>
                  <div
                    className="flex justify-center md:mt-4"
                    onClick={gaEventTracker(category.title)}
                  >
                    <Card2 category={category} />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HomePage;
